/* eslint-disable */
class PipeItem {
  symbol;

  payload;

  providerNamesList = new Set();

  isLoading = false;

  isLoaded = false;

  constructor(symbol, payload = {}) {
    this.symbol = symbol;
    this.payload = payload;
  }

  addProviderName(name) {
    this.providerNamesList.add(name);
  }

  deleteProviderName(name) {
    this.providerNamesList.delete(name);
  }
}

class ProviderItem {
  apiSymbols = new Map();

  name;

  constructor(name) {
    this.name = name;
  }

  checkStatus() {
    let status = true;
    this.apiSymbols.forEach((value) => {
      if (!value.isLoaded) status = false;
    });

    return status;
  }

  addApiSymbol(symbol) {
    this.apiSymbols.set(symbol, {
      isLoaded: false,
    });
  }

  loadedApiSymbol(symbol) {
    this.apiSymbols.set(symbol, {
      isLoaded: true,
    });
  }
}

class PipeGroup {

  name;
  responsesData = new Map();
  responseStatus = new Map();

  constructor(name) {
    this.name = name;
  }

  clearAll() {
    this.responsesData = new Map();
    this.responseStatus = new Map();
  }

  addRequest(requestName) {
    this.responsesData.set(requestName, false);
    this.responseStatus.set(requestName, false);
  }

  addResponseData(requestName, response) {
    this.responsesData.set(requestName, response)
    this.responseStatus.set(requestName, true)
  }

  getStatus() {
    return [...this.responseStatus.values()].indexOf(false) < 0
  }

  getResponses() {
    return [...this.responsesData.values()];
  }
}

class PipeProviderStateSingleton {
  static instance;

  _requests = new Map();
  _pipeList = new Set();
  _pipes = new Map();
  _providers = new Map();
  _callbacks = new Map();
  _callbacksReturnsGroup = new Map();
  _pipeGroup = new Map();
  _executeApi;
  _callbackRootLoading;

  constructor() {
    if (PipeProviderStateSingleton.instance) return PipeProviderStateSingleton.instance;
    PipeProviderStateSingleton.instance = this;
  }

  changeStatesOfARequest(index, state) {
    const target = this._requests.get(index)
    if (target) {
      this._requests.set(index, {
        isLoaded: state
      })
    }
  }

  clearPipeGroup() {
    if (this._pipeGroup.size > 0) {
      this._pipeGroup.forEach((group) => {
        group.clearAll();
      })
    }
  }

  execute() {
    this._pipes.forEach((pipe, index) => {
      if (!pipe.isLoading && !pipe.isLoaded) {
        pipe.isLoading = true;
        if (this._executeApi) {
          this._executeApi(pipe.symbol, () => {
            pipe.isLoaded = true;
            pipe.isLoading = false;
            this.changeStatesOfARequest(index, true);
            this.checkProvidersApiSymbols(pipe.providerNamesList, index);
            this.checkIfRootLoadingIsDone();
          }, {
            ...(pipe.payload || {}),
            pipeInstanceSingleton: PipeProviderStateSingleton.instance
          });
        }
      } else if (pipe.isLoaded) {
        this.changeStatesOfARequest(index, true);
        this.checkProvidersApiSymbols(pipe.providerNamesList, index);
        this.checkIfRootLoadingIsDone();
      }
    });
  }

  executeCallback(providerName) {
    const prd = this._providers.get(providerName);
    if (prd.checkStatus() && this._callbacks.get(providerName)) {
      this._callbacks.get(providerName)();
    }
  }

  checkProvidersApiSymbols(providerList, symbolOrAlias) {
    providerList.forEach((provider) => {
      const prd = this._providers.get(provider);
      if (prd.apiSymbols.get(symbolOrAlias)) prd.loadedApiSymbol(symbolOrAlias);
      this.executeCallback(provider);
    });
  }

  setCallbackRootLoading(callback) {
    if (callback) {
      this._callbackRootLoading = callback;
    }
  }

  checkIfRootLoadingIsDone() {
    if (this.checkIfAllRequestsAsComplete() && this._callbackRootLoading) {
      this._callbackRootLoading()
    }
  }

  checkIfAllRequestsAsComplete() {
    const requestStates = this._requests.values();
    let statusOfAllRequests = true;
    [...requestStates].forEach(({ isLoaded }) => {
      if (!isLoaded && statusOfAllRequests) statusOfAllRequests = false;
    })
    return statusOfAllRequests;
  }

  addStateToRootLoadingRequest(requestName) {
    this._requests.set(requestName, {
      isLoaded: false,
    })
  }

  formatPipeItem(item, providerName) {
    if (typeof item === 'object') {
      if (!this._providers.get(providerName)) {
        this._providers.set(providerName, new ProviderItem(providerName));
      }
      const {
        symbol,
        alias,
        payload,
      } = item;
      const index = alias || symbol;
      if (!this._pipeList.has(index)) this._pipeList.add(index);
      if (!this._pipes.get(index)) {
        const NewItem = new PipeItem(symbol, payload);
        NewItem.addProviderName(providerName);
        this._pipes.set(index, NewItem);
      } else {
        const Item = this._pipes.get(index);
        Item.addProviderName(providerName);
      }
      this.addStateToRootLoadingRequest(index);
      const prd = this._providers.get(providerName);
      prd.addApiSymbol(index);
    } else if (typeof item === 'string') {
      this.formatPipeItem({
        symbol: item,
        alias: null,
        payload: null,
      }, providerName);
    }
  }

  setExecuteApi(executeApi) {
    this._executeApi = executeApi;
  }

  addCallback(providerName, callback) {
    this._callbacks.set(providerName, callback);
  }

  addPipeIndex(pipeItems, providerName) {
    pipeItems.forEach((item) => {
      this.formatPipeItem(item, providerName);
    });
    this.execute();
  }

  addReturnCallbackGroup(groupName, callback = () => {}) {
    this._callbacksReturnsGroup.set(groupName, callback);
    this._pipeGroup.set(groupName, new PipeGroup(groupName))
  }

  appendInGroupRequest(groupName, requestName) {
    if (this._pipeGroup.get(groupName)) {
      const group = this._pipeGroup.get(groupName)
      group.addRequest(requestName);
    }
  }

  appendInGroupResponse(groupName, requestName, response) {
    if (this._pipeGroup.get(groupName)) {
      const group = this._pipeGroup.get(groupName)
      group.addResponseData(requestName, response);
    }
  }

  executeCallbackForGroup(groupName, callback = () => {}) {
    if (this._pipeGroup.get(groupName)) {
      const group = this._pipeGroup.get(groupName)
      const callbackToRedux = this._callbacksReturnsGroup.get(groupName)
      if (group.getStatus() && callbackToRedux) {
        callbackToRedux(group.getResponses())
        callback()
      }
    }
  }
}
export default PipeProviderStateSingleton;
